import { PaymentProvider } from "@greenflagdate/shared";
import { StripeCardFields } from "../../../components/PaymentForm/StripeCardFields";
import { PaymentClientAdapter } from "../types";
import { translateStripeCode } from "./errorMap";
import { loadStripeJs } from "./stripeJs";

export const stripeClientAdapter: PaymentClientAdapter = {
  provider: PaymentProvider.Stripe,
  preload: loadStripeJs,
  CardFields: StripeCardFields,
  translateError: translateStripeCode,
};
